import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { useGlobalContext } from '../GlobalContext';

const ListKelompok = () => {
  const { api, isReady } = useGlobalContext();

  const [kelompok, setKelompok] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [newKelompok, setNewKelompok] = useState({
    kode: '',
    unitkerja: '',
    postagihan: '1', // Default value for postagihan
    cekbayar: '1',   // Default value for cekbayar
  });

  const [editKelompok, setEditKelompok] = useState({
    kode: '',
    unitkerja: '',
    postagihan: '1',
    cekbayar: '0',
  });

  const getKelompok = async () => {
    try {
      const res = await api.get('/api/unit');
      const hasil = Array.isArray(res.data) ? res.data : (res.data.data || []);
      setKelompok(hasil);
    } catch (error) {
      console.error('❌ Gagal memuat data kelompok:', error);
      setKelompok([]);
    }
  };

  useEffect(() => {
    if (isReady) {
      getKelompok();
    }
  }, [isReady]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewKelompok({ ...newKelompok, [name]: value });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditKelompok({ ...editKelompok, [name]: value });
  };

  const handleAddKelompok = async () => {
    if (!newKelompok.kode || !newKelompok.unitkerja) {
      alert('Kode dan Unit Kerja tidak boleh kosong.');
      return;
    }
    try {
      const payload = {
        kode: newKelompok.kode,
        unitkerja: newKelompok.unitkerja,
        postagihan: parseInt(newKelompok.postagihan),
        cekbayar: parseInt(newKelompok.cekbayar),
      };
      await api.post('/api/unit', payload);
      alert('Data berhasil ditambahkan.');
      setModalOpen(false);
      setNewKelompok({ kode: '', unitkerja: '', postagihan: '1', cekbayar: '1' }); // Reset to default values
      getKelompok();
    } catch (error) {
      console.error('❌ Gagal menambahkan data:', error.response?.data || error.message);
      alert('Gagal menambahkan data.');
    }
  };

  const handleEditClick = (item) => {
    setEditKelompok({
      ...item,
      postagihan: String(item.postagihan),
      cekbayar: String(item.cekbayar),
    });
    setModalEditOpen(true);
  };

  const handleUpdateKelompok = async () => {
    if (!editKelompok.kode || !editKelompok.unitkerja) {
      alert('Kode dan Unit Kerja tidak boleh kosong.');
      return;
    }
    try {
      const payload = {
        unitkerja: editKelompok.unitkerja,
        postagihan: parseInt(editKelompok.postagihan),
        cekbayar: parseInt(editKelompok.cekbayar),
      };
      await api.patch(`/api/unit/${editKelompok.kode}`, payload);
      alert('Data berhasil diperbarui.');
      setModalEditOpen(false);
      getKelompok();
    } catch (error) {
      console.error('❌ Gagal memperbarui data:', error.response?.data || error.message);
      alert('Gagal memperbarui data.');
    }
  };

  const handleDeleteKelompok = async (kode) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data ini?")) {
      try {
        await api.delete(`/api/unit/${kode}`);
        alert('Data berhasil dihapus.');
        getKelompok();
      } catch (error) {
        console.error('❌ Gagal menghapus data:', error.response?.data || error.message);
        alert('Gagal menghapus data.');
      }
    }
  };

  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      width: "60px",
      center: true,
    },
    {
      name: "Kode",
      width: "100px",
      selector: (row) => row.kode,
      sortable: true,
      center: true,
    },
    {
      name: "Unit Kerja",
      selector: (row) => row.unitkerja,
      sortable: true,
    },
    {
      name: "Aksi",
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button className="btn btn-info btn-sm" onClick={() => handleEditClick(row)}>
            <i className="fa fa-edit" />
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => handleDeleteKelompok(row.kode)}>
            <i className="fa fa-trash" />
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "150px",
      center: true,
    },
  ];

  const filteredData = kelompok.filter(
    (item) =>
      item.kode.toLowerCase().includes(searchText.toLowerCase()) ||
      item.unitkerja.toLowerCase().includes(searchText.toLowerCase())
  );

  const customStyles = {
    headCells: {
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        paddingTop: '12px',
        paddingBottom: '12px',
        borderBottom: '1px solid #dee2e6',
        borderRight: '2px solid #ddd',
      },
    },
    cells: {
      style: {
        fontSize: '14px',
        paddingTop: '10px',
        borderRight: '1px solid #ddd',
        paddingBottom: '10px',
        borderBottom: '1px solid #dee2e6',
      },
    },
    rows: {
      style: {
        borderBottom: '1px solid #dee2e6',
      },
    },
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header">
        <div className="d-flex justify-content-end align-items-center w-90">
          <h4 className="mb-0" style={{ fontSize: "22px" }}>DAFTAR KELOMPOK</h4>
          <button
            className="btn btn-primary btn-sm"
            style={{ fontSize: "14px", padding: "6px 14px" }}
            onClick={() => {
              // Reset only Kode and Unit Kerja for the add form
              setNewKelompok({ kode: '', unitkerja: '', postagihan: '1', cekbayar: '1' });
              setModalOpen(true);
            }}
          >
            Tambah Data
          </button>
        </div>
      </div>

      <div className="card-body">
        
        <div style={{ maxWidth: "90%", margin: "0 auto" }}>
          <div className="mb-2 d-flex justify-content-end">
            <input
              type="text"
              className="form-control form-control-sm"
              style={{ maxWidth: "200px" }}
              placeholder="Cari kode/unit kerja..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            striped
            dense
            highlightOnHover
            responsive
            customStyles={customStyles}
            className="table table-bordered"
          />        
        </div>
        
      </div>

      {/* Modal Tambah */}
      {modalOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">TAMBAH KELOMPOK</h5>
                <button type="button" className="btn-close" onClick={() => setModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>Kode</label>
                  <input
                    type="text"
                    name="kode"
                    className="form-control"
                    value={newKelompok.kode}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label>Unit Kerja</label>
                  <input
                    type="text"
                    name="unitkerja"
                    className="form-control"
                    value={newKelompok.unitkerja}
                    onChange={handleInputChange}
                  />
                </div>
                {/* Removed Posisi Tagihan and Status from Tambah Kelompok modal */}
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleAddKelompok}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit */}
      {modalEditOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">EDIT KELOMPOK</h5>
                <button type="button" className="btn-close" onClick={() => setModalEditOpen(false)}></button>
              </div>
              <div className="modal-body">
                <div className="form-group mb-2">
                  <label>Kode</label>
                  <input disabled className="form-control" name="kode" value={editKelompok.kode} />
                </div>
                <div className="form-group mb-2">
                  <label>Unit Kerja</label>
                  <input
                    className="form-control"
                    name="unitkerja"
                    value={editKelompok.unitkerja}
                    onChange={handleEditChange}
                  />
                </div>
                {/* Posisi Tagihan and Status remain in Edit modal */}
                <div className="form-group mb-2">
                  <label>Posisi Tagihan</label>
                  <select className="form-control" name="postagihan" value={editKelompok.postagihan} onChange={handleEditChange}>
                    <option value="1">Cadin</option>
                    <option value="2">Non Cadin</option>
                  </select>
                </div>
                <div className="form-group mb-2">
                  <label>Status</label>
                  <select className="form-control" name="cekbayar" value={editKelompok.cekbayar} onChange={handleEditChange}>
                    <option value="1">Aktif</option>
                    <option value="0">Non Aktif</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={() => setModalEditOpen(false)}>Batal</button>
                <button className="btn btn-success btn-sm" onClick={handleUpdateKelompok}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListKelompok;